import React, { useState, useEffect } from "react";
import { DateUtils } from "../utils/UILib";

interface DateDifferenceProps {
    date1: string;
    date2: string;
}

const DateDifference: React.FC<DateDifferenceProps> = ({ date1, date2 }) => {
    const [bgColor, setBgColor] = useState("white");
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);
    // if (date1 && date2) {
    //     const firstDate = new Date(date1);
    //     const secondDate = new Date(date2);
    // } else { return <div>error</div> }

    useEffect(() => {
        if (date1 && date2) {
            //   const firstDate = new Date(date1);
            //   const secondDate = new Date(date2);

            // Farkı milisaniye cinsinden hesapla
            const differenceInMs = Math.abs(secondDate.getTime() - firstDate.getTime());

            // Farkı dakikaya çevir
            const differenceInMinutes = differenceInMs / (1000 * 60);

            // Eğer fark 5 dakikadan az ise sarı yap, değilse beyaz
            if (differenceInMinutes < 5) {
                setBgColor("yellow");
            } else {
                setBgColor("white");
            }
        }
    }, [date1, date2]); // date1 ve date2 değiştiğinde useEffect tekrar çalışır

    return (
        <div className={`text-small`} style={{ color: bgColor, padding: "5px" }}>{DateUtils.dateFormat(firstDate, secondDate)}</div>
        // <div style={{ color: bgColor, padding: "20px" }}>
        //   <p>Date 1: {date1}</p>
        //   <p>Date 2: {date2}</p>
        // </div>
    );
};

export default DateDifference;
